// Pets: unlocked and levelled with pet food from bosses; persist across ascension.
import type { AddStat, MultStat } from '../game/stats';

export type PetBonus =
  | { kind: 'mult'; stat: MultStat; perLevel: number } // 1 + perLevel * level
  | { kind: 'add'; stat: AddStat; perLevel: number };  // perLevel * level

export interface PetDef {
  id: string;
  name: string;
  icon: string;
  color: string;
  bonus: PetBonus;
  /** `{v}` is replaced with the formatted value. */
  desc: string;
}

export const PETS: readonly PetDef[] = [
  { id: 'ember',  name: 'Ember',  icon: '🦊', color: '#ff8a3d', bonus: { kind: 'mult', stat: 'tapDamage', perLevel: 0.1 }, desc: 'Tap damage {v}' },
  { id: 'pip',    name: 'Hoot',    icon: '🦉', color: '#c9a36b', bonus: { kind: 'mult', stat: 'gold', perLevel: 0.1 }, desc: 'Coins {v}' },
  { id: 'grub',   name: 'Clicky',   icon: '🪲', color: '#6fbf4a', bonus: { kind: 'mult', stat: 'bossDamage', perLevel: 0.1 }, desc: 'Giant damage {v}' },
  { id: 'nimbus', name: 'Nimbus', icon: '☁️', color: '#bfe3ff', bonus: { kind: 'add', stat: 'manaRegenPct', perLevel: 0.03 }, desc: 'Energy regeneration {v}' },
  { id: 'fang',   name: 'Pup',   icon: '🐶', color: '#9aa5b1', bonus: { kind: 'mult', stat: 'heroDamage.melee', perLevel: 0.15 }, desc: 'Warrior Guardian damage {v}' },
  { id: 'talon',  name: 'Paper Hawk',  icon: '🕊️', color: '#b5835a', bonus: { kind: 'mult', stat: 'heroDamage.ranged', perLevel: 0.15 }, desc: 'Ranger Guardian damage {v}' },
  { id: 'wisp',   name: 'Toy Sprite',   icon: '🚁', color: '#d6b8ff', bonus: { kind: 'mult', stat: 'heroDamage.spell', perLevel: 0.15 }, desc: 'Mage Guardian damage {v}' },
  { id: 'drake',  name: 'Mini Dragon',  icon: '🐲', color: '#e03c3c', bonus: { kind: 'mult', stat: 'allDamage', perLevel: 0.05 }, desc: 'All damage {v}' },
];

export const PET_BY_ID: ReadonlyMap<string, PetDef> = new Map(PETS.map((p) => [p.id, p]));

export const PET_TUNING = {
  /** Active pet strikes once every N taps (auto-taps count). */
  tapsPerAttack: 5,
  /** Pet strike = tap damage x (attackBase + attackPerLevel * level). */
  attackBase: 2,
  attackPerLevel: 0.5,
  /** The active pet's passive bonus counts this many times. */
  activeBonusMult: 2,
  /** Boss kills drop food with this chance (amount 1..maxDrop, random pet). */
  foodChance: 0.1,
  maxDrop: 3,
  /** First clear of every Nth stage guarantees 1 food. */
  guaranteedEvery: 10,
} as const;

/** Food needed to go from `level` to `level + 1` (level 0 -> 1 = unlock, costs 1). */
export function petLevelCost(level: number): number {
  return Math.max(1, level);
}
